module.exports = __webpack_public_path__ + "img/saven_logo_black.b0f9475e.png";